import {PATHS} from "@/constants/routes";
import {Navigate} from "react-router";

export function Remittances() {
  return (
    <Navigate
      to={PATHS.TRANSFERS}
      replace
    />
  );
}
